<template>
  <div class="paisabase-intro-page">
    <div class="container">
      <div class="title">PaisaBase Introduction</div>
      <div class="subtitle">01/08/2025 10:00:00</div>

      <h2>What is PCoin?</h2>
      <p>
        PCoin is the token of the PaisaBase platform. When you withdraw cash,
        <strong>1 PCoin = 1 rupee</strong>.
      </p>

      <hr />

      <h2>"Buy" means?</h2>
      <p>This process means that you buy PCoin with rupees.</p>
      <div class="card">
        For example, when you buy PCoin with 1000 rupees you can get
        <strong>1033 PCoin</strong>, and <strong>33 PCoin</strong> is your
        profit.
      </div>

      <hr />

      <h2>"Sell" means?</h2>
      <p>
        This process is the process of cashing out your profits. The PCoin you
        earn on the platform can be converted into rupees at a
        <strong>1:1 ratio</strong>.
      </p>
      <p>
        You can initiate a withdrawal and specify a wallet to receive rupee
        funds.
      </p>

      <div class="warning">
        ⚠️ During the withdrawal process,
        <strong>do not log in to your wallet</strong>. Otherwise, the
        withdrawal process will stop and you will need to activate your UPI
        wallet on the platform again.
      </div>

      <hr />

      <h2>How you earn?</h2>
      <p>
        Through "buy", you will get <strong>3.3%</strong> profit for each
        transaction, and then withdraw it to your bank card through "sell".
      </p>
      <p>
        Once your 30-day INR trade volume (excluding USDT) reaches
        <strong>₹3,000,000</strong>, you become a Premium Member and earn
        <strong>4%</strong> for each transaction.
      </p>
      <p>
        You can start with a very small amount of "buy", repeat it many times a
        day, and your daily income will be very considerable.
      </p>

      <hr />

      <h2>+UPI Account</h2>
      <p>
        Now it will be very simple to upload your UPI information, just need to
        bind your wallet app to our platform, no need to upload more
        complicated information.
      </p>

      <div class="card">
        Currently only supports the following wallets:<br />
        <strong>Mobikwik</strong>, <strong>Freecharge</strong>,
        <strong>Navi</strong>
      </div>

      <p>Each wallet has two tabs:</p>
      <ul>
        <li>
          <strong>Buy</strong> – Use this wallet to buy PCoin with rupees.
        </li>
        <li>
          <strong>Sell</strong> – Use this wallet to sell PCoin to rupees, which
          can be used to withdraw your profit.
        </li>
      </ul>

      <hr />

      <h2>Advantages of Wallet Working Mode</h2>
      <ul>
        <li>No need to give too much phone permission</li>
        <li>No need KYC</li>
        <li>No need to give bank card and netbanking information</li>
        <li>No need to add beneficiaries</li>
        <li>
          No need to click start or stop button. Actively obtain payment orders
          through "buy"
        </li>
        <li>No amount limit, no cards limit, no subline limit</li>
        <li>
          Get <strong>0.3% + 0.1% rebate</strong> from subordinates for life, no upper
          limit
        </li>
        <li>Any bank card is available</li>
        <li>
          You can transfer funds between your own cards at will, no need to
          wait for some "payout order"
        </li>
        <li>No age limit</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaisaBaseIntro",
  mounted() {
    document.title = "PaisaBase Introduction";
  }
};
</script>

<style scoped>
.paisabase-intro-page {
  margin: 0;
  padding: 0;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", sans-serif;
  color: #222444;
  letter-spacing: 0.02em;
  box-sizing: border-box;
  min-height: 100%;
}

.paisabase-intro-page .container {
  max-width: 780px;
  margin-bottom: 40px;
  background-color: #fff;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.paisabase-intro-page .title {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 8px;
}

.paisabase-intro-page .subtitle {
  text-align: center;
  font-size: 14px;
  color: #999;
  margin-bottom: 32px;
}

.paisabase-intro-page h2 {
  font-size: 20px;
  margin-top: 36px;
  margin-bottom: 24px;
  padding-left: 10px;
  border-left: 6px solid #007aff;
  line-height: 1;
  font-weight: 600;
  color: #2c3e50;
}

.paisabase-intro-page p {
  font-size: 16px;
  line-height: 1.4;
  margin: 12px 0;
}

.paisabase-intro-page strong {
  color: #007aff;
  font-weight: 600;
}

.paisabase-intro-page ul {
  padding-left: 20px;
  margin-top: 10px;
}

.paisabase-intro-page ul li {
  font-size: 16px;
  line-height: 1.8;
  list-style-type: disc;
}

.paisabase-intro-page .card {
  color: #666888;
  background-color: #f0f7ff;
  border-left: 4px solid #007aff;
  padding: 14px 20px;
  border-radius: 6px;
  margin: 20px 0;
  font-size: 14px;
}

.paisabase-intro-page .warning {
  color: #666;
  background-color: #f6f6f6;
  border-left: 4px solid #d0d0d0;
  padding: 14px 20px;
  border-radius: 6px;
  margin: 24px 0;
  font-size: 14px;
}

.paisabase-intro-page hr {
  border: none;
  border-top: 1px solid #eee;
  margin: 36px 0;
}
</style>
